import styled from 'styled-components';

const ValidationLine = styled.span``;

ValidationLine.displayName = 'ValidationLine';

export default ValidationLine;
